import { getTaskGroups } from '@dispatch/shared/services';
import { TaskGroup } from '@dispatch/shared/types';
import { useQuery } from '../useQuery';

export const useGetTaskGroupOptions = (pageSize?: number) => {
  const { data, status } = useQuery(
    ['task-groups'],
    () => getTaskGroups(pageSize),
    { staleTime: 300000 }
  );

  const options = data
    ?.filter((tg: TaskGroup) => !!tg.name)
    .map((tg: TaskGroup) => {
      return { title: tg.name, value: tg.id };
    });

  return {
    taskGroupOptions: options,
    taskGroupOptionsStatus: status,
  };
};
